import { _getLockedNodeIds } from "./actions";
import { diagram } from "./initial";

// POST "tree-data"
function _createReqParams(getState, ids, isInitialLoad) {
    return {
        ...diagram.diagramParams,
        id: ids,
        ln: isInitialLoad ? [] : _getLockedNodeIds(),
        direction: diagram.diagramParams.direction,
        level: getState().charts.leftPanel.level,
        historicalData: diagram.diagramParams.history,
        rt: diagram.diagramParams.rt,
        histFromYear: diagram.diagramParams.dateFrom,
        histToYear: diagram.diagramParams.dateTo,
        sharePct: diagram.diagramParams.shareChecked ? diagram.diagramParams.sharePct : 0
    };
}

// POST "path-data"
function _createPathReqParams() {
    return {
        startId: diagram._rootIdList[0],
        endId: diagram._rootIdList[1],
        level: parseInt(diagram._initParams.level) || 1,
        historicalData: diagram._initParams.hist === "true",
        direction: diagram.diagramParams.direction,
        sharePct: diagram.diagramParams.shareChecked ? diagram.diagramParams.sharePct : 0,
        histFromYear: diagram._initParams.from,
        histToYear: diagram._initParams.to,
        rt: diagram._initParams.rtFull,
        timeout: parseInt(diagram._initParams.timeout) || 30
    };
}

// POST "expanded-node-data"
function _createExpandReqParams(ids, nodeLevel, orientLevel, nodeRelations, expandOnlyId, rootId) {
    return Object.assign({}, diagram.diagramParams, {
        id: ids,
        historicalData: diagram.diagramParams.history,
        rt: diagram.diagramParams.rt,
        nodeRelations,
        nodeLevel,
        orientLevel,
        histFromYear: diagram.diagramParams.dateFrom,
        histToYear: diagram.diagramParams.dateTo,
        direction: diagram.diagramParams.direction,
        sharePct: diagram.diagramParams.shareChecked ? diagram.diagramParams.sharePct : 0,
        rootId: rootId,
        expandOnlyId
    })
}

export { _createExpandReqParams, _createPathReqParams, _createReqParams };
